import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { asyncScheduler, Observable, of } from 'rxjs';
import { map, observeOn, switchMap } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { IntegrationMDMPairingService, PairCode } from '@rocksoft/settings-sdk';
import { catchErrorWithToast } from '@rocksoft/shared/toast';
import { PairingCodeComponent } from './pairing-code.component';

@Component({
  selector: 'era-pairing-code',
  templateUrl: './pairing-code.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PairingCodeComponent, AsyncPipe],
})
export class PairingCodeContainerComponent {
  private readonly pairingService = inject(IntegrationMDMPairingService);
  private readonly store = inject(Store);

  public readonly categoryId = input<string>();

  public readonly code$: Observable<PairCode | null>;

  constructor() {
    this.code$ = toObservable(this.categoryId).pipe(
      switchMap((categoryId) =>
        categoryId
          ? this.pairingService
              .getPairCode({ categoryId })
              .pipe(
                catchErrorWithToast(
                  (error) => ({ type: '[PairingCode] Get Pair Code Error', error }),
                  'Could not load pairing code'
                )
              )
          : of(null)
      ),
      observeOn(asyncScheduler),
      map((result) => {
        if (result !== null && typeof result === 'object' && 'toast' in result) {
          this.store.dispatch(result);
          return null;
        }
        return result;
      })
    );
  }
}
